// What a task is called on its card and detail page (product owner,
// 2026-10-18), the rule in functions/functions/task_identity.py and the
// phone's TaskCardLabels: the Task ID it carries (userVisibleId, else
// actualTaskId), else the asset's human ID, else the template's name and the
// time. Shared cases: api/tests/fixtures/task_title_cases.json.

const text = (value) => (typeof value === 'string' ? value.trim() : '');

/** { kind: 'task_id' | 'asset' | 'template', value } */
export function taskTitleParts(task, assetCode = '') {
  const own = text(task?.userVisibleId) || text(task?.actualTaskId);
  if (own) return { kind: 'task_id', value: own };
  const code = text(assetCode) || text(task?.asset_integration_result?.code);
  if (code) return { kind: 'asset', value: code };
  return { kind: 'template', value: text(task?.templateName) || text(task?.template_name) };
}

/**
 * The line under the title, { label, value } or null: on an asset template a
 * Task ID field the operator also filled in ("Work order: WO-1234"), carried
 * on the task as secondaryTaskId / secondaryTaskIdLabel. Nothing when empty
 * or the same as the title.
 */
export function taskSubtitle(task, titleValue = '') {
  const value = text(task?.secondaryTaskId);
  if (!value || value === text(titleValue)) return null;
  return { label: text(task?.secondaryTaskIdLabel) || 'Task ID', value };
}

/** taskSubtitle as "Label: value", or ''. */
export function taskSubtitleText(task, titleValue = '') {
  const found = taskSubtitle(task, titleValue);
  return found ? `${found.label}: ${found.value}` : '';
}

function toDate(value) {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  if (typeof value.seconds === 'number') return new Date(value.seconds * 1000);
  if (typeof value._seconds === 'number') return new Date(value._seconds * 1000);
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function shortTime(date) {
  return date.toLocaleString(undefined, {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

/** The title to show. Never "Unknown" while there is something better. */
export function taskTitle(task, { assetCode = '', fallback = 'Task' } = {}) {
  const { kind, value } = taskTitleParts(task, assetCode);
  if (kind !== 'template') return value;
  const when = toDate(task?.createdAt || task?.submittedAt || task?.created_at);
  const name = value || fallback;
  return when ? `${name} · ${shortTime(when)}` : name;
}
